import { useAppDispatch } from 'legacy/lut/hooks/useAppDispatch'
import { useCallback } from 'react'

import { useChangeNotApplicable } from 'partner360/hooks/finSob/useChangeNotApplicable'

import { setActiveStepId, updateStep } from '../features/planningWizard'
import { IWizardStep } from '../models/IWizardStep'

interface IUseNotApplicablePlanningStep {
  changeLoading: (isLoading: boolean) => void
  partnerId: string
  fYear: number
}

export const useNotApplicablePlanningStep = ({
  changeLoading,
  partnerId,
  fYear,
}: IUseNotApplicablePlanningStep) => {
  const dispatch = useAppDispatch()

  const onChangeNotApplicable = useChangeNotApplicable({
    partnerId,
    fYear,
  })

  const handleNotApplicable = useCallback(
    async (step: IWizardStep, isNeedDropCommitment?: boolean) => {
      changeLoading(true)

      const newIsApplicableValue = step.isApplicable ? 0 : 1
      const updatedStep = {
        ...step,
        isApplicable: newIsApplicableValue,
      }

      dispatch(updateStep({ updatedStep }))
      dispatch(setActiveStepId(updatedStep.id))

      await onChangeNotApplicable({
        isNotApplicable: updatedStep.isApplicable ? 0 : 1,
        categoryField: updatedStep.category ?? '',
        isNeedDropCommitment,
      })

      changeLoading(false)
    },
    [changeLoading, dispatch, onChangeNotApplicable]
  )

  const updatePlanningStepApplicable = useCallback(
    async (step: IWizardStep, isNeedDropCommitment?: boolean) => {
      dispatch(setActiveStepId(step.id))
      await handleNotApplicable(step, isNeedDropCommitment)
    },
    [dispatch, handleNotApplicable]
  )

  return { updatePlanningStepApplicable }
}
